import type { PlayBeat, StorePageDraftContent } from "./types";
import {
  blurbMaxCharacters,
  ctaLabelMaxCharacters,
  closingLineMaxCharacters,
  beatTitleMaxCharacters,
  beatBodyMaxCharacters,
  minBeats,
  maxBeats,
} from "./content-limits";
import { lengthError, type FieldError } from "./field-validation";
import { linkErrors } from "./link-validation";
import { mediaErrors } from "./validate-media";

function beatErrors(beats: readonly PlayBeat[]): FieldError[] {
  const errors: FieldError[] = [];

  if (beats.length < minBeats || beats.length > maxBeats) {
    errors.push({
      field: "play_beats",
      message: `How-you-play beats: ${minBeats}-${maxBeats} beats`,
    });
  }

  beats.forEach((beat, i) => {
    const titleErr = lengthError({
      field: `play_beats[${i}].title`,
      label: `beat ${i + 1} title`,
      value: beat.title,
      max: beatTitleMaxCharacters,
    });

    if (titleErr) errors.push(titleErr);

    const bodyErr = lengthError({
      field: `play_beats[${i}].body`,
      label: `beat ${i + 1} body`,
      value: beat.body,
      max: beatBodyMaxCharacters,
    });

    if (bodyErr) errors.push(bodyErr);
  });
  return errors;
}

export function validateStorePageContent(
  content: StorePageDraftContent,
): FieldError[] {
  const errors: FieldError[] = [];

  if (content.blurb !== null) {
    const err = lengthError({
      field: "blurb",
      label: "premise/blurb",
      value: content.blurb,
      max: blurbMaxCharacters,
    });

    if (err) errors.push(err);
  }

  if (content.cta_label !== null) {
    const err = lengthError({
      field: "cta_label",
      label: "CTA label",
      value: content.cta_label,
      max: ctaLabelMaxCharacters,
    });

    if (err) errors.push(err);
  }

  if (content.closing_line !== null) {
    const err = lengthError({
      field: "closing_line",
      label: "closing line",
      value: content.closing_line,
      max: closingLineMaxCharacters,
    });

    if (err) errors.push(err);
  }

  if (content.play_beats !== null) {
    errors.push(...beatErrors(content.play_beats));
  }

  errors.push(...mediaErrors(content.hero_media));
  errors.push(...linkErrors(content.links));
  return errors;
}
